export default {
    ROTINA: 1,
    EMERGENCIA: 2
}